import { IHasClassName } from '@/interfaces';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type TProps = IHasClassName & {
  text?: ReactNode;
};

const TableCellEmpty = ({ className, text = 'Non défini' }: TProps) =>
  <span className={cn(
    'text-neutral-300 italic',
    className
  )}>
    {text}
  </span>;

export default TableCellEmpty;
